// Offline check-in queue: when a check-in fails because the network is down,
// it is stored here and replayed as soon as the connection comes back.
// The server only accepts a check-in for the current day (Paris time), so a
// stale entry from a previous day is dropped at flush time (403).

const KEY = 'lpc_offline_checkin';

export function queueCheckin(userId, payload) {
  try {
    localStorage.setItem(KEY, JSON.stringify({
      userId,
      payload,
      queuedAt: new Date().toISOString(),
    }));
    return true;
  } catch (e) {
    return false;
  }
}

export function getQueuedCheckin() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function clearQueuedCheckin() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) { /* ignore */ }
}
